export enum AmpEventSourceTypeZi {
  REACHOUT = 'ReachOutNG5',
  CE_REACHOUT = 'CE-Extension',
  CE = 'CENG5',
  GO = 'GrowNG5',
  OTHER = 'Other'
}
